/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import { SliderPicker } from 'react-color';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import AddAlert from '@material-ui/icons/AddAlert';
import Button from '../../sharedComponents/CustomButtons/Button';
import useInputValue from '../../../utils/hooks/useInputValue';
import ZoneEditModal from '../ZoneModal/index';
import SnackbarContent from '../../sharedComponents/Snackbar/SnackbarContent';
import { useStyles, Centered } from './styles';
import { minPermisos } from '../../../constants/permits'
import ramdomColor from '../../../utils/randomColor';

const ZoneCreateComponent = (props) => {
  const {
    onSubmit,
    permisos,
    idPermiso,
    onSubmitEdit,
    show,
    ...rest } = props

  const [color, setColor] = useState(ramdomColor());
  const classes = useStyles();
  const zona = useInputValue('');
  const minValue = permisos[idPermiso]

  const handlerSubmit = (event) => {
    event.preventDefault();
    setColor(ramdomColor())
    onSubmit({
      zona: zona.value,
      color,
    });
  };

  return (
    <>
      <div className={classes.root}>
        {show && <ZoneEditModal onSubmitEdit={onSubmitEdit} {...rest} />}
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12}>
            { minValue >= minPermisos.CREAR ? (
              <Card className={classes.card}>
                <CardContent>
                  <Typography variant='h5' component='h2'>
                    Cree una zona y seleccione un color
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={8} md={6}>
                      <Centered>
                        <form className={classes.root} autoComplete='off' onSubmit={handlerSubmit}>
                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={12}>
                              <Centered>
                                <TextField
                                  required
                                  id='standard-required'
                                  label='Nombre de la zona'
                                  {...zona}
                                />
                                <br />
                              </Centered>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12}>
                              <Centered>
                                <Button
                                  type='onSubmit'
                                >
                                  Guardar
                                </Button>

                              </Centered>
                            </Grid>
                          </Grid>
                        </form>
                      </Centered>
                    </Grid>
                    {/*  */}
                    <Grid item xs={12} sm={8} md={6}>
                      <Typography color='textSecondary'>
                        Seleccione un color
                      </Typography>
                      <Card>
                        <div>
                          <SliderPicker
                            color={color}
                            // eslint-disable-next-line no-shadow
                            onChangeComplete={(color) => { setColor(color.hex); }}
                          />
                          <div style={{
                            backgroundColor: color,
                            height: '5rem',
                            width: '100%',
                          }}
                          >
                            {color}
                          </div>
                        </div>
                      </Card>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            ) : (
              <SnackbarContent
                message='No cuentas con permisos suficientes'
                icon={AddAlert}
              />
            )}
          </Grid>
        </Grid>
      </div>
    </>
  );

};

export default ZoneCreateComponent;
